var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderInvoice"},[_vm._t("order_info_title"),_vm._t("orderInvoiceContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }